module.exports = __webpack_public_path__ + "img/IMG_6984_L_WoodMatted.9efe207a.jpg";